import { getInitials, setDate } from "./helpers";

export const listOfAnswerOptions = [
	{
		value: "1",
		label: "1",
	},
	{
		value: "2",
		label: "2",
	},
	{
		value: "3",
		label: "3 ",
	},
	{
		value: "4",
		label: "4",
	},
	{
		value: "5",
		label: "5 (A,B,C,D,E)",
	},
	{
		value: "6",
		label: "6",
	},
	{
		value: "7",
		label: "7",
	},
	{
		value: "8",
		label: "8",
	},
	{
		value: "9",
		label: "9",
	},
	{
		value: "10",
		label: "10",
	},
	{
		value: "11",
		label: "11",
	},
	{
		value: "12",
		label: "12",
	},
	{
		value: "13",
		label: "13",
	},
	{
		value: "14",
		label: "14",
	},
	{
		value: "15",
		label: "15",
	},
	{
		value: "16",
		label: "16",
	},
	{
		value: "17",
		label: "17",
	},
	{
		value: "18",
		label: "18",
	},
	{
		value: "19",
		label: "19",
	},
	{
		value: "20",
		label: "20",
	},
];

export const listOfKeys = [
	{
		value: "1",
		label: "1 Version",
	},
	{
		value: "2",
		label: "2 Versions",
	},
	{
		value: "3",
		label: "3 Versions",
	},
	{
		value: "4",
		label: "4 Versions",
	},
	{
		value: "5",
		label: "5 Versions",
	},
	{
		value: "6",
		label: "6 Versions",
	},
	{
		value: "7",
		label: "7 Versions",
	},
	{
		value: "8",
		label: "8 Versions",
	},
	{
		value: "9",
		label: "9 Versions",
	},
];

export const listOfWeights = [
	{
		value: "1",
		label: "1",
	},
	{
		value: "2",
		label: "2",
	},
	{
		value: "3",
		label: "3",
	},
	{
		value: "4",
		label: "4",
	},
	{
		value: "5",
		label: "5",
	},
	{
		value: "6",
		label: "6",
	},
	{
		value: "7",
		label: "7",
	},
	{
		value: "8",
		label: "8",
	},
	{
		value: "9",
		label: "9",
	},
];

export const listOfKeysComp = [
	{
		value: "1",
		label: "1",
	},
	{
		value: "2",
		label: "2",
	},
	{
		value: "3",
		label: "3",
	},
	{
		value: "4",
		label: "4",
	},
	{
		value: "5",
		label: "5",
	},
];

export const listOfKeysFormula = [
	{
		value: "1",
		label: "1",
	},
	{
		value: "2",
		label: "2",
	},
	{
		value: "3",
		label: "3",
	},
	{
		value: "4",
		label: "4",
	},
];

export const listClassNum = [
	{
		key: "",
		name: "",
		value: "",
		label: "",
	},
];

export const courierDepts = [22, 23, 52, 100, 64, 31, 91, 35, 95, 83, 39, 46, 79, 84, 30, 94];

export const sidedSided = [
	{
		value: "Double sided",
		label: "Double sided",
	},
	{
		value: "Single sided",
		label: "Single sided",
	},
];

export const yesOrNoOptions = [
	{
		value: "Yes",
		label: "Yes",
	},
	{
		value: "No",
		label: "No",
	},
];

export const addLeadingZerosQuestions = (numQuestions) => {
	let numQuestionsString = numQuestions.toString();

	if (numQuestionsString.length === 1) {
		numQuestionsString = "00".concat(numQuestionsString);
	} else if (numQuestionsString.length === 2) {
		numQuestionsString = "0".concat(numQuestionsString);
	}
	return numQuestionsString;
};

export const addLeadingZerosAnswers = (numAnswers) => {
	let numAnswersString = numAnswers.toString();
	if (numAnswersString.length === 1) {
		numAnswersString = "0".concat(numAnswersString);
	}
	return numAnswersString;
};

function buildApiKeysFromState(keysState) {
	// keysState is our internal state.keys:
	// {
	//   "1": {
	//     version: "1",
	//     itemsByQuestion: {
	//       1: { omit: false, weight: 1, mr: false, ... },
	//       2: { omit: true,  weight: 1, mr: false, ... },
	//       ...
	//     }
	//   },
	//   "2": { ... },
	// }

	if (!keysState || typeof keysState !== "object") {
		return {};
	}

	const out = {};

	Object.entries(keysState).forEach(([versionLabel, versionObj], idx) => {
		// We'll generate keys like "Key 1", "Key 2", etc. OR "Key A"
		// Your backend code tries a couple fallbacks:
		//   - key_info.version
		//   - if only one key, version=None
		//   - fallback parse from the dict key name "Key X"
		//
		// We can be explicit and stable here.

		const keyName = `Key ${versionObj.version || versionLabel || idx + 1}`;

		const itemsPayload = {};
		Object.entries(versionObj.itemsByQuestion || {}).forEach(([qNum, itemData]) => {
			itemsPayload[qNum] = {
				omit: !!itemData.omit,
				weight: itemData.weight !== undefined && itemData.weight !== null ? itemData.weight : 1,
				mr: !!itemData.mr, // include if you track multiple-response per item
			};
		});

		out[keyName] = {
			version: versionObj.version || versionLabel || "",
			items: itemsPayload,
		};
	});

	return out;
}

export function serializeScannerStateForApi(
	state,
	classNumList,
	ccid,
	ccidString,
	confirmedOfficeInstructor,
) {
	let hqNum = addLeadingZerosQuestions(String(state.hqNum));
	let lqNum = addLeadingZerosQuestions(String(state.lqNum));
	let numAnswers = addLeadingZerosAnswers(state.qLen);
	const courseTitle = state.courseTitle;
	let classTitle = "";
	if (classNumList) {
		if (
			classNumList.find(
				(item) => item.value === state.class_ids[0] || item.value === state.class_ids,
			)
		) {
			classTitle = classNumList.find(
				(item) => item.value === state.class_ids[0] || item.value === state.class_ids,
			).label;
		} else {
			classTitle = state.courseTitle ? state.courseTitle : "No Matching Course Found";
		}
	} else {
		classTitle = state.courseTitle ? state.courseTitle : "No Matching Course Found";
	}

	if (classTitle.split(" ").length > 4) {
		//combine the first two indexes
		let classTitle1 = classTitle.split(" ").slice(0, 2).join("").trim();
		let classTitle2 = classTitle.split(" ").slice(2).join(" ").trim();
		classTitle = classTitle1 + " " + classTitle2;
	}

	const listOfClassIds = Array.isArray(state.class_ids)
		? state.class_ids.join(",")
		: String(state.class_ids);

	const listOfCombineIds = Array.isArray(state.combineIds)
		? state.combineIds.join(",")
		: String(state.combineIds);

	const classNum = listOfCombineIds ? listOfClassIds + "," + listOfCombineIds : listOfClassIds;

	const selectedClassIds = Array.isArray(state.class_ids)
		? state.class_ids
		: state.class_ids !== undefined &&
			  state.class_ids !== null &&
			  String(state.class_ids).trim() !== ""
			? [state.class_ids]
			: [];

	let resolvedTerm = state.term;
	if (
		(!resolvedTerm || String(resolvedTerm).trim() === "") &&
		classNumList &&
		selectedClassIds.length > 0
	) {
		const firstSelectedClassId = Number(selectedClassIds[0]);
		const matchedClass = classNumList.find((item) => Number(item?.value) === firstSelectedClassId);
		if (matchedClass?.term_value !== undefined && matchedClass?.term_value !== null) {
			resolvedTerm = matchedClass.term_value;
		}
	}

	const normalizedTerm =
		resolvedTerm === undefined ||
		resolvedTerm === null ||
		String(resolvedTerm).trim() === "" ||
		String(resolvedTerm).trim().toLowerCase() === "undefined" ||
		String(resolvedTerm).trim().toLowerCase() === "null"
			? null
			: Number.isNaN(Number(resolvedTerm))
				? null
				: Number(resolvedTerm);
	return {
		userid: confirmedOfficeInstructor ? ccidString : ccid,
		caddr1: state.instructorName,
		accountnum: 502306,
		coursetitle: classTitle.substring(0, 16),
		dept: state.deptID,
		program: state.program,
		caddr2: state.department
			.trim()
			.replace(/ *\([^)]*\) */g, "")
			.substring(0, 32),
		caddr3: state.address ? state.address.substring(0, 60) : "Department Office",
		rqdate: setDate(),
		lqnum: lqNum,
		hqnum: hqNum,
		qlen: numAnswers,
		nkeys: state.nKeys,
		a: state.a,
		b: state.b,
		c: ["1", "4"].includes(state.program) ? state.c : "1",
		d: state.d,
		e: state.e,
		f: state.f,
		k: state.k,
		l: state.l,
		m: state.m,
		n: state.n,
		o: state.o,
		p: state.p,
		pocketflag: "1",
		initials: getInitials(state.instructorName),
		instructor_name: state.instructorName,
		email1: state.email1,
		email2: state.email2,
		phone: state.phone,
		speedcode: 84311,
		numopen: state.numOpen,
		docsize: state.docSize,
		notes:
			state.program === "2" && state.schema
				? state.schema === "Other"
					? "SCHEMA: " + state.schemaNotes + " | " + state.notes
					: "SCHEMA: " + state.schema + " | " + state.notes
				: state.notes,
		status: "Received",
		classNum: classNum,
		class_ids:
			state.class_ids && state.class_ids !== ""
				? Array.isArray(state.class_ids)
					? state.class_ids.join(",")
					: String(state.class_ids)
				: null,
		term: normalizedTerm,
		keys: buildApiKeysFromState(state.keys),
		delivery: state.delivery,
		booklets:
			Number(state.program === 4) && state.booklets && state.booklets !== ""
				? state.booklets
				: null,
		sheets:
			Number(state.program === 4) && state.sheets && state.sheets !== "" ? state.sheets : null,
		sided:
			Number(state.program === 4) && state.sided && state.sided !== ""
				? state.sided === "Single sided"
					? "single"
					: "double"
				: null,
		tsqs_upload:
			Number(state.program === 4) && state.tsqs_upload && state.tsqs_upload !== ""
				? state.tsqs_upload === "upload"
					? 1
					: 0
				: null,
		exam_type:
			Number(state.program === 4) && state.exam_type && state.exam_type !== ""
				? state.exam_type
				: null,
	};
}
